module.exports = __webpack_public_path__ + "media/images/emblems/Kandersteg-coat_of_arms-622f3cfc588ddfdd7ad82f1f3d74a083.svg";